import { render, staticRenderFns } from "./CallDescription.vue?vue&type=template&id=32a6f6bb&"
import script from "./CallDescription.vue?vue&type=script&lang=js&"
export * from "./CallDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports